import { AxiosRequestConfig } from 'axios';

import { ExercisesDestroyResponseItem } from '../shared';

interface Unarchive {
  classAssignments: ExercisesDestroyResponseItem[];
  folderId: string;
}

interface UpdateConfig extends AxiosRequestConfig {
  body: Unarchive;
  data: Unarchive;
  method: 'PUT';
  url: `/exercises/${string}`;
}

export interface ExercisesUpdateResponse {
  name?: string;
}

/**
 * PUT /api/v2/exercises/{id}
 */
export const update = (id: string, data: Unarchive): UpdateConfig => {
  return {
    method: 'PUT',
    url: `/exercises/${id}`,
    body: data,
    data,
  } as const;
};
